import HeardContainer from "../components/heardContainer";
import tgLogo from "../assets/img/tg.png"

export default function SmartMonitor () {
  document.title = '海马-智能监控'
  const keyword = document.querySelector('meta[name="keyword"]')
  keyword.setAttribute('content', "WhatsApp监控、Telegram监控，管理，多开")
  const description = document.querySelector('meta[name="description"]')
  description.setAttribute('content', "一体化社交账号管理与实时监测平台。在合法授权下，可实时查看 WhatsApp、Telegram 的活动，集中管理群聊、视频、图片及对话内容。还能查看已编辑或删除的信息，帮助及时识别潜在风险与异常行为。")
  return (
    <div className="bg-gradient-radial from-[#7b61ff]/10 via-transparent to-[#070814] text-[#eaf5ff] font-sans">
      <div className="max-w-6xl mx-auto p-7">
        <HeardContainer tilte="海马-智能监控" subtitle="一体化社交账号管理与实时监控平台" />
        <section className="max-w-6xl mx-auto grid md:grid-cols-2 gap-5">
          <div className="bg-[#ffffff]/5 p-5 rounded-2xl backdrop-blur-sm shadow-[0_10px_30px_rgba(2,6,23,0.6)]">
            <div className="flex items-center gap-3">
              <h2 className="text-lg">海马‑智能监控 ❤️管理公司社交账号更轻松❤️</h2>
            </div>
            <p className="text-[#eaf5ff]/60 mb-4">支持WhatsApp、Telegram多账号管理、员工多开授权、实时监控和违规警报，从源头杜绝泄密并快速溯源。</p>
            <div className="flex flex-col gap-3">
              <div className="flex gap-3 items-start">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">
                  <img className="w-5 h-5" src={tgLogo} alt="tg" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold">多Telegram管理</h3>
                  <p className="text-[#eaf5ff]/60 text-sm">帮助用户轻松管理多个Telegram账号，集中控制。</p>
                </div>
              </div>

              <div className="flex gap-3 items-start">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">👥</div>
                <div>
                  <h3 className="text-sm font-semibold">员工多开与权限</h3>
                  <p className="text-[#eaf5ff]/60 text-sm">可随时赋予或收回账号使用权，灵活管理团队成员。</p>
                </div>
              </div>

              <div className="flex gap-3 items-start">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">📊</div>
                <div>
                  <h3 className="text-sm font-semibold">实时监控</h3>
                  <p className="text-[#eaf5ff]/60 text-sm">即时查看员工使用情况，确保工作效率与安全。</p>
                </div>
              </div>

              <div className="flex gap-3 items-start">
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-[#7b61ff] to-[#00d4ff] flex items-center justify-center font-bold">⚠️</div>
                <div>
                  <h3 className="text-sm font-semibold">智能监控与报警</h3>
                  <p className="text-[#eaf5ff]/60 text-sm">监控违规操作、记录异常行为，快速定位问题源头。</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-b from-[#061022] to-[#081226] p-5 rounded-xl backdrop-blur-sm border border-white/10 h-[420px] overflow-hidden">
            <strong>监控演示面板</strong>
            <div className="mt-3 space-y-2">
              <div className="p-2 rounded-md bg-gradient-to-r from-[#7b61ff]/8 to-[#00d4ff]/6">员工A登录Telegram账号 #1</div>
              <div className="p-2 rounded-md bg-gradient-to-r from-[#7b61ff]/8 to-[#00d4ff]/6">员工B登录Telegram账号 #2</div>
              <div className="p-2 rounded-md bg-gradient-to-r from-[#7b61ff]/8 to-[#00d4ff]/6">系统检测到异常操作并触发报警</div>
              <div className="text-[#eaf5ff]/60 text-sm mt-2">右侧为实时监控记录（模拟）</div>
            </div>
          </div>
        </section>
        <footer className="mt-8 text-[#eaf5ff]/60 text-sm text-center">
          <div>适配企业与团队 · 支持多平台账号集中管理</div>
          <div className="relative mt-4">
            <div className="absolute left-1/2 -translate-x-1/2 inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
            <div className="absolute left-1/2 -translate-x-1/2 inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
            <div className="absolute left-1/2 -translate-x-1/2 inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
            <div className="absolute left-1/2 -translate-x-1/2 inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />
          </div>
        </footer>
      </div>
    </div>
  );
}
